import { TeamsMeetingsByOrganizerOfficeIdsClients_teamsMeetingsByOrganizerOfficeIds_edges as TeamsMeetingEdge } from '@ms/yammer-graphql';
import { schema } from 'normalizr';

import { processTeamsMeeting, processTeamsMeetingEdge } from '../strategies/teamsMeeting';

const getId = (edge: TeamsMeetingEdge) => edge.node.id;

export type TeamsMeetingSchema = typeof teamsMeetingSchema;
export const teamsMeetingEdgeSchema = new schema.Entity(
  'teamsMeetings',
  {},
  {
    idAttribute: getId,
    processStrategy: processTeamsMeetingEdge,
  }
);

export const teamsMeetingSchema = new schema.Entity('teamsMeetings', {}, { processStrategy: processTeamsMeeting });

export type TeamsMeetingEdgesSchema = typeof teamsMeetingEdgesSchema;
export const teamsMeetingEdgesSchema = new schema.Array(teamsMeetingEdgeSchema);
